import * as React from 'react'
import notice, { INoticeProps } from '../notice'
import './index.scss'

interface IToastProps extends INoticeProps {}

const showToast = (
  props: IToastProps | string,
  type: 'info' | 'success' | 'error'
) => {
  let options: IToastProps

  if (typeof props === 'string') {
    options = {
      content: props,
      duration: 3000,
    }
  } else {
    options = props
  }

  if (type !== 'info') {
    options.content = (
      <div className='toast-inner'>
        <i
          className={`iconfont ${
            type === 'error' ? 'icon-warning-circle' : 'icon-checked'
          }`}
        >
        </i>
        {options.content}
      </div>
    )
  }
  return notice.noticeMessage({ ...options, className: 'notice-toast' })
}

export default {
  info (options: IToastProps | string) {
    return showToast(options, 'info')
  },
  success (options: IToastProps | string) {
    return showToast(options, 'success')
  },
  error (options: IToastProps | string) {
    return showToast(options, 'error')
  },
  hide () {
    notice.destory()
  },
}
